import Vue from 'vue'

// axios
import axios from 'axios'

// const isDevelopment = process.env.NODE_ENV === 'development'
// const defaultBaseURL = isDevelopment ? '/api/v1' : 'http://127.0.0.1:8000/api/v1'

const axiosIns = axios.create({
    // You can add your headers here
    // ================================
    // baseURL: process.env.VUE_APP_API_BASE_URL || defaultBaseURL,
    // baseURL: 'http://192.168.1.77:8085/api/v1',

    // Live Server
    // baseURL: 'https://api.cromis.app/api/v1',
    // Mkwawa cromis live
    baseURL: 'https://api.buying.mkwawa.co.tz/api/v1',
    // Mkwawa cromis test_
    // baseURL: 'https://api.test.mkwawa.co.tz/api/v1',
    // Test Server
    // baseURL: 'https://dev.cromis.app/api/v1',
    // timeout: 1000,
    // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
